'use strict';

var defineProperty = require('../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var UnPlugged = function UnPlugged(props) {
  return React__default["default"].createElement("svg", _objectSpread({
    width: 885,
    height: 458,
    viewBox: "0 0 885 458",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React__default["default"].createElement("path", {
    fill: "url(#prefix__paint0_radial)",
    d: "M68.667 247h816v167h-816z"
  }), React__default["default"].createElement("g", {
    filter: "url(#prefix__filter0_d)"
  }, React__default["default"].createElement("rect", {
    x: 416.667,
    y: 3,
    width: 120,
    height: 180,
    rx: 8,
    fill: "#C2DBF0"
  }), React__default["default"].createElement("rect", {
    x: 416.667,
    y: 3,
    width: 120,
    height: 180,
    rx: 8,
    stroke: "#0069C0",
    strokeWidth: 2
  })), React__default["default"].createElement("rect", {
    x: 441.167,
    y: 35.5,
    width: 71,
    height: 47,
    rx: 23.5,
    fill: "#fff",
    stroke: "#0069C0"
  }), React__default["default"].createElement("rect", {
    x: 441.167,
    y: 103.5,
    width: 71,
    height: 47,
    rx: 23.5,
    fill: "#fff",
    stroke: "#0069C0"
  }), React__default["default"].createElement("circle", {
    cx: 477.167,
    cy: 19.5,
    r: 4,
    fill: "#0069C0",
    fillOpacity: 0.24,
    stroke: "#0069C0"
  }), React__default["default"].createElement("path", {
    fill: "#0069C0",
    d: "M474.647 19.885l4.698-1.71.342.94-4.698 1.71z"
  }), React__default["default"].createElement("path", {
    fill: "#0069C0",
    d: "M477.553 22.02l-1.71-4.698.94-.342 1.71 4.698z"
  }), React__default["default"].createElement("circle", {
    cx: 477.167,
    cy: 166.5,
    r: 4,
    fill: "#0069C0",
    fillOpacity: 0.24,
    stroke: "#0069C0"
  }), React__default["default"].createElement("path", {
    fill: "#0069C0",
    d: "M474.647 166.885l4.698-1.71.342.94-4.698 1.71z"
  }), React__default["default"].createElement("path", {
    fill: "#0069C0",
    d: "M477.553 169.02l-1.71-4.698.94-.342 1.71 4.698z"
  }), React__default["default"].createElement("rect", {
    x: 423.667,
    y: 7,
    width: 72,
    height: 2,
    rx: 1,
    fill: "#fff"
  }), React__default["default"].createElement("rect", {
    x: 440.667,
    y: 177,
    width: 80,
    height: 2,
    rx: 1,
    fill: "#0069C0"
  }), React__default["default"].createElement("rect", {
    opacity: 0.4,
    x: 176.667,
    y: 247,
    width: 600,
    height: 2,
    rx: 1,
    fill: "#0069C0"
  }), React__default["default"].createElement("rect", {
    x: 503.667,
    y: 7,
    width: 24,
    height: 2,
    rx: 1,
    fill: "#fff"
  }), React__default["default"].createElement("circle", {
    cx: 462.667,
    cy: 59,
    r: 5.5,
    fill: "#0069C0",
    fillOpacity: 0.8,
    stroke: "#0069C0"
  }), React__default["default"].createElement("circle", {
    cx: 462.667,
    cy: 127,
    r: 5.5,
    fill: "#0069C0",
    fillOpacity: 0.8,
    stroke: "#0069C0"
  }), React__default["default"].createElement("circle", {
    cx: 489.667,
    cy: 59,
    r: 5.5,
    fill: "#0069C0",
    fillOpacity: 0.8,
    stroke: "#0069C0"
  }), React__default["default"].createElement("circle", {
    cx: 489.667,
    cy: 127,
    r: 5.5,
    fill: "#0069C0",
    fillOpacity: 0.8,
    stroke: "#0069C0"
  }), React__default["default"].createElement("path", {
    d: "M258.178 231c-27.666.5-96.7 2-151.5 4-68.5 2.5-113.01 67.5-91.01 141.5s163.51 33.5 208.51 77",
    stroke: "#0069C0",
    strokeWidth: 9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React__default["default"].createElement("g", {
    filter: "url(#prefix__filter1_f)"
  }, React__default["default"].createElement("path", {
    d: "M258.178 263c-27.666.5-96.7 2-151.5 4-68.5 2.5-107.01 51.5-85.01 125.5",
    stroke: "#00314A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), React__default["default"].createElement("g", {
    filter: "url(#prefix__filter2_f)"
  }, React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M294.793 265h-35.237a.889.889 0 110-1.778h35.187a4 4 0 013.924-3.222h72a4 4 0 010 8h-72a4.002 4.002 0 01-3.874-3z",
    fill: "#00314A",
    fillOpacity: 0.24
  })), React__default["default"].createElement("rect", {
    x: 365.667,
    y: 223,
    width: 12,
    height: 46,
    rx: 6,
    transform: "rotate(-90 365.667 223)",
    fill: "#EDF6FE",
    stroke: "#0069C0",
    strokeWidth: 2
  }), React__default["default"].createElement("rect", {
    x: 365.667,
    y: 251,
    width: 12,
    height: 46,
    rx: 6,
    transform: "rotate(-90 365.667 251)",
    fill: "#EDF6FE",
    stroke: "#0069C0",
    strokeWidth: 2
  }), React__default["default"].createElement("mask", {
    id: "prefix__a",
    fill: "#fff"
  }, React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M293.762 239.848a3.995 3.995 0 01-1.095.152h-32a4 4 0 01-4-4v-8a4 4 0 014-4h32c.228 0 .452.019.669.056C296.572 207.496 311.16 195 328.667 195h40a4 4 0 014 4v64a4 4 0 01-4 4h-40c-16.829 0-30.961-11.548-34.905-27.152z"
  })), React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M293.762 239.848a3.995 3.995 0 01-1.095.152h-32a4 4 0 01-4-4v-8a4 4 0 014-4h32c.228 0 .452.019.669.056C296.572 207.496 311.16 195 328.667 195h40a4 4 0 014 4v64a4 4 0 01-4 4h-40c-16.829 0-30.961-11.548-34.905-27.152z",
    fill: "#3387CD"
  }), React__default["default"].createElement("path", {
    d: "M293.762 239.848l1.939-.49-.504-1.997-1.981.563.546 1.924zm-.426-15.792l-.332 1.972 1.921.324.374-1.913-1.963-.383zm-.12 13.868a2 2 0 01-.549.076v4c.566 0 1.118-.079 1.642-.228l-1.093-3.848zm-.549.076h-32v4h32v-4zm-32 0a2 2 0 01-2-2h-4a6 6 0 006 6v-4zm-2-2v-8h-4v8h4zm0-8a2 2 0 012-2v-4a6 6 0 00-6 6h4zm2-2h32v-4h-32v4zm32 0c.116 0 .229.01.337.028l.664-3.944a5.923 5.923 0 00-1.001-.084v4zm2.632-1.561C298.355 208.801 312.135 197 328.667 197v-4c-18.482 0-33.878 13.192-37.294 30.672l3.926.767zM328.667 197h40v-4h-40v4zm40 0a2 2 0 012 2h4a6 6 0 00-6-6v4zm2 2v64h4v-64h-4zm0 64a2 2 0 01-2 2v4a6 6 0 006-6h-4zm-2 2h-40v4h40v-4zm-40 0c-15.892 0-29.241-10.904-32.966-25.642l-3.878.98C295.986 256.809 310.9 269 328.667 269v-4z",
    fill: "#0069C0",
    mask: "url(#prefix__a)"
  }), React__default["default"].createElement("rect", {
    x: 374.667,
    y: 213,
    width: 32,
    height: 4,
    rx: 2,
    fill: "#fff"
  }), React__default["default"].createElement("rect", {
    x: 320.667,
    y: 200,
    width: 48,
    height: 4,
    rx: 2,
    fill: "#C2DBF0"
  }), React__default["default"].createElement("rect", {
    x: 260.667,
    y: 228,
    width: 32,
    height: 2,
    rx: 1,
    fill: "#C2DBF0"
  }), React__default["default"].createElement("rect", {
    x: 279.667,
    y: 235,
    width: 16,
    height: 2,
    rx: 1,
    fill: "#0069C0"
  }), React__default["default"].createElement("rect", {
    x: 328.667,
    y: 258,
    width: 40,
    height: 4,
    rx: 2,
    fill: "#0069C0"
  }), React__default["default"].createElement("rect", {
    x: 374.667,
    y: 243,
    width: 32,
    height: 4,
    rx: 2,
    fill: "#fff"
  }), React__default["default"].createElement("rect", {
    x: 247.667,
    y: 239,
    width: 14,
    height: 6,
    rx: 3,
    transform: "rotate(-90 247.667 239)",
    fill: "#3387CD",
    stroke: "#0069C0",
    strokeWidth: 2
  }), React__default["default"].createElement("rect", {
    x: 237.667,
    y: 239,
    width: 14,
    height: 6,
    rx: 3,
    transform: "rotate(-90 237.667 239)",
    fill: "#3387CD",
    stroke: "#0069C0",
    strokeWidth: 2
  }), React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M340.667 217.693c-7.347 0-13.307 5.96-13.307 13.307s5.96 13.307 13.307 13.307 13.307-5.96 13.307-13.307-5.96-13.307-13.307-13.307zm-.693 23.974v-8.347h-4.64L342 220.333v8.347h4.467l-6.493 12.987z",
    fill: "#0069C0"
  }), React__default["default"].createElement("defs", null, React__default["default"].createElement("filter", {
    id: "prefix__filter0_d",
    x: 411.667,
    y: 0,
    width: 130,
    height: 190,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, React__default["default"].createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), React__default["default"].createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), React__default["default"].createElement("feOffset", {
    dy: 2
  }), React__default["default"].createElement("feGaussianBlur", {
    stdDeviation: 2
  }), React__default["default"].createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), React__default["default"].createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), React__default["default"].createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), React__default["default"].createElement("filter", {
    id: "prefix__filter1_f",
    x: 0.971,
    y: 248.5,
    width: 271.707,
    height: 158.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, React__default["default"].createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), React__default["default"].createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), React__default["default"].createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "effect1_foregroundBlur"
  })), React__default["default"].createElement("filter", {
    id: "prefix__filter2_f",
    x: 246.667,
    y: 248,
    width: 140,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, React__default["default"].createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), React__default["default"].createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), React__default["default"].createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "effect1_foregroundBlur"
  })), React__default["default"].createElement("radialGradient", {
    id: "prefix__paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 146 -509.128 0 476.667 247)"
  }, React__default["default"].createElement("stop", {
    stopColor: "#2196F3",
    stopOpacity: 0.08
  }), React__default["default"].createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0
  }))));
};

module.exports = UnPlugged;
